export const getCurrentMonth = (): string => {
    const current = new Date();

    current.setMonth(current.getMonth());

    return current.toLocaleString('default', { month: 'long' });
};

export const getCurrentYear = (): string => {
    const current = new Date();

    current.setFullYear(current.getFullYear());

    return current.toLocaleString('default', { year: 'numeric' });
};
